export default (rating = 0) => (+rating).toFixed(1);
